import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from '@openng/optimus-ui/button';
import { PopoverModule } from '@openng/optimus-ui/popover';
import { ToggleSwitchModule } from '@openng/optimus-ui/toggleswitch';
import { TooltipModule } from '@openng/optimus-ui/tooltip';
import { ThemeService } from '../theme.service';
import { ThemePresetId } from '../presets';

@Component({
  selector: 'app-theme-switcher',
  imports: [
    FormsModule,
    ButtonModule,
    PopoverModule,
    ToggleSwitchModule,
    TooltipModule,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './theme-switcher.html',
})
export class ThemeSwitcherComponent {
  private readonly themeService = inject(ThemeService);

  protected readonly presets = this.themeService.presets;
  protected readonly presetId = this.themeService.presetId;
  protected readonly activePreset = this.themeService.activePreset;
  protected readonly darkMode = this.themeService.darkMode;

  protected selectPreset(id: ThemePresetId): void {
    this.themeService.setPreset(id);
  }

  protected setDarkMode(dark: boolean): void {
    this.themeService.setDarkMode(dark);
  }
}
